"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    SlashForward: function() {
        return SlashForward;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const SlashForward = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M16.4064 2.08619C16.9111 2.3105 17.1384 2.90146 16.9141 3.40614L8.91406 21.4061C8.68976 21.9108 8.0988 22.1381 7.59411 21.9138C7.08943 21.6895 6.86213 21.0986 7.08644 20.5939L15.0864 2.59387C15.3107 2.08918 15.9017 1.86189 16.4064 2.08619Z",
        fill: "currentColor"
    })
}), "SlashForward");
const _default = SlashForward;
